/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { NotificationTypes, NotificationState } from './types';

const INITIAL_STATE: NotificationState = {
  notification: {
    notifications: [
      {
        actable_type: '',
      },
    ],
    total_entries: 0,
    notification_type: '',
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<NotificationState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case NotificationTypes.SHOW_REQUEST:
        draft.notification = INITIAL_STATE.notification;
        draft.request.loading = true;
        break;
      case NotificationTypes.SHOW_SUCCESS:
        if (!result) return;

        draft.notification = result?.data;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case NotificationTypes.SHOW_FAILURE:
        draft.notification = INITIAL_STATE.notification;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};

export default reducer;
